// extracted by mini-css-extract-plugin
export default {"footer":"DirectoryPopupFooter_footer__IHxed"};